export default "__VITE_ASSET__tSF9LJAD__"